import { useState } from "react";
import "./styles/Faq.css";

const faqData = [
  {
    question: "How does solar save me money?",
    answer:
      "By generating your own electricity, you reduce your utility bill and protect yourself from rising energy costs. Many homeowners see immediate savings.",
  },
  {
    question: "Is solar right for my home?",
    answer:
      "If your roof gets good sunlight and you're tired of high electric bills, solar may be a great fit. We’ll assess your roof, utility rates, and home energy usage.",
  },
  {
    question: "How much does it cost to go solar?",
    answer:
      "Costs vary, but $0-down financing is available. You can own your system or finance it with a loan or lease — we help you understand your best options.",
  },
  {
    question: "What incentives are available for solar?",
    answer:
      "Federal tax credits, local rebates, and net metering programs can significantly reduce the cost of solar. We make sure you don’t miss out on any benefits.",
  },
  {
    question: "Will solar increase my home value?",
    answer:
      "Yes, studies show homes with solar sell faster and for more money. It’s a long-term investment in your property and the planet.",
  },
];

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const faqStructuredData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqData.map((item) => ({
      "@type": "Question",
      name: item.question,
      acceptedAnswer: { "@type": "Answer", text: item.answer },
    })),
  };

  return (
    <section className="standalone-faq-section">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData) }}
      />
      <div className="standalone-faq-container">
        <h2 className="standalone-faq-heading">Solar FAQs</h2>
        {faqData.map((item, index) => (
          <div key={index} className="standalone-faq-item">
            <button className="standalone-faq-question" onClick={() => toggle(index)}>
              {item.question}
              <span className="standalone-faq-toggle">{openIndex === index ? "−" : "+"}</span>
            </button>
            {openIndex === index && <p className="standalone-faq-answer">{item.answer}</p>}
          </div>
        ))}
      </div>
    </section>
  );
}
